import { Location } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable, Injector, inject } from '@angular/core';

@Injectable()
export class CustomErrorHandlerService implements ErrorHandler {
  private location = inject(Location);
  private errorWrapper = inject<{ error: Error }>('ERROR_WRAPPER' as never, { optional: true });
  private injector = inject(Injector);

  handleError(error: Error) {
    if (!error) return;
    if ('picflow-handled' in error) return;
    error['picflow-handled'] = true;
    let httpError = undefined;
    if (error instanceof HttpErrorResponse) {
      httpError = error;
      error = new Error(error.message, { cause: error });
    }

    console.error(error);
    // eslint-disable-next-line no-debugger
    debugger;

    if (this.errorWrapper) {
      this.errorWrapper.error = error;
    } else {
      import('./services/sentry.service').then(({ SentryService }) => {
        const service = this.injector.get(SentryService);
        service?.captureException(error, {
          path: this.location.path(),
          ...(httpError ? httpError : {}),
        });
      });
    }
  }
}
